import './assets/css/main.less'
import Vue from 'vue'
import App from './App.vue'
import router from "./router/index.js";
import store from "./store";
import VueI18n from 'vue-i18n';
import http from './http/index.js'
import utils from './utils/utils.js'
import './utils/flexible'
import './utils/vant.js' // 按需自动导入 vant 组件
import './utils/devTool.js'

window.onload = function () {
  // 禁止 ios 中双击、双指缩放页面
  document.addEventListener('gesturestart', function (event) {
    event.preventDefault();
  });
}

Vue.use(VueI18n);
Vue.config.productionTip = false
Vue.prototype.$http = http
Vue.prototype.$utils = utils
// 格式化金额
Vue.filter("formatAmount", (amount) => utils.formatAmount(amount))

// 设置初始语言
let initLang = localStorage.getItem("lang")
let langList = ['zh-cn', 'id-id']
if (!initLang || !langList.includes(initLang)) {
  initLang = "id-id"
  localStorage.setItem("lang", initLang)
}
// 导入语言包
const i18n = new VueI18n({
  globalInjection: true,
  locale: initLang, // 将要切换的语言，可以通过url拼的参数获取，用户行为select选择获取，本地manifest配置获取等，根据场景动态获取
  messages: {
    'zh-cn': require('./assets/lang/zh_cn.json'), // 简体中文
    'id-id': require('./assets/lang/id_id.json'), // 马来语
  }
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
